import { gql } from '@apollo/client';

export const GET_MEETINGS_FOR_TRACK_SELECTOR = gql`
  query GetMeetingsForTrackSelector($date: Date!, $hasTips: Boolean) {
    meetings(date: $date, has_tips: $hasTips) {
      meeting_id
      track {
        track_id
        code
        name
        state
        type
      }
    }
  }
`;